window.SockJS = require('sockjs-client');
require('./onsas-client');
module.exports = 'ons-actionslider';
